module.exports = __webpack_public_path__ + "img/carbon-dioxide.0cd82d68.svg";